import { render } from "./DebitPaymentConfirmation.vue?vue&type=template&id=4d898e00&ts=true"
import script from "./DebitPaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./DebitPaymentConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__